/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Campaigns selectors
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.12.0
 */
import { createSelector } from 'reselect';

import { tableMetaFilterSelector } from '../../modules/table/selectors';

/*
* -------------------------------------------
*  Селекторы для получения значений по пред фильтрации списков
* -------------------------------------------
*/

export const makeSelectCampaignsAccountFilter = (metaUrl?: string) => createSelector(
    tableMetaFilterSelector(metaUrl),
    (tableFilter) => tableFilter.clientId?.value ?? '');

export const makeSelectCampaignsSubscriberFilter = (metaUrl?: string) => createSelector(
    tableMetaFilterSelector(metaUrl),
    (tableFilter) => tableFilter.msisdn?.value ?? '');
